exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agent-option[data-v-6ef265b7]{padding:8px 0}.agent-name[data-v-6ef265b7]{display:flex;align-items:center;gap:10px;margin-bottom:4px}.agent-id[data-v-6ef265b7]{font-size:.85em;color:#6c757d;font-weight:400}.agent-email[data-v-6ef265b7]{font-size:.9em;margin-top:4px;display:flex;align-items:center}.agent-email i[data-v-6ef265b7]{font-size:.85em}", ""]);

// exports
